/**
 * 分组选择V2(TreeSelect)
 */
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TreeSelect, TreeSelectProps } from 'antd';
import { groupCategoryRequestV2 } from '@/service/groupManage';
import { filterMultipleCateData } from '@/utils/cate';
import { setCateTree } from '@/store/cateTree/actions';

interface CategoryTreeSelectProps extends TreeSelectProps {
  value?: string; // 选择的数据
  onChange?: (value: string) => void; // 选择时调用的方法
}
const CategoryTreeSelectV2 = (props: CategoryTreeSelectProps) => {
  const userStore = useSelector((state: any) => state.userStore);
  const cateTreeStore = useSelector((state: any) => state.cateTreeStore);

  const { userDetail } = userStore;
  const { value, onChange } = props;
  const [categoryData, setCategoryData] = useState([]);
  const [selectValue, setSelectValue] = useState<string | undefined>();
  const dispatch = useDispatch();

  const isMountedRef = useRef(true); // 添加标志

  useEffect(() => {
    getCategoryData();
    return () => {
      isMountedRef.current = false; // 清理时设置标志
    };
  }, []);

  useEffect(() => {
    setSelectValue(value);
  }, [value]);

  useEffect(() => {
    dispatch(setCateTree(categoryData))
  }, [categoryData]);

  // 获取分组树形数据
  const getCategoryData = async () => {
    let data;

    //如果有分类树数据，不重新请求
    if (cateTreeStore.cateTree?.length) {
      data = cateTreeStore.cateTree
    } else {
      const res = await groupCategoryRequestV2();
      data = res.data?.data || [];
    }

    if (!isMountedRef.current) return;
    // 针对有多个分组的账号特殊过滤分组数据
    if (userDetail.multiCate) {
      setCategoryData(filterMultipleCateData(data, JSON.parse(userDetail.multiCate)));
    } else {
      setCategoryData(data);
    }
  }

  // 选择树节点
  const onTreeChange = (value: string) => {
    setSelectValue(value);
    onChange && onChange(value)
  }



  return (
    <TreeSelect
      {...props}
      treeNodeFilterProp="title"
      fieldNames={{ value: 'id' }}
      allowClear
      value={selectValue}
      style={{ width: '100%' }}
      showSearch
      placeholder="请选择"
      treeData={categoryData}
      onChange={onTreeChange}
      dropdownMatchSelectWidth={false}
      showCheckedStrategy="SHOW_PARENT"
      maxTagCount="responsive"
    />
  )
}

export default CategoryTreeSelectV2;
